import request from '@/services/interceptor.js'

export const get_commesse = (search) => {
    return request({ url: '/commesse', method: 'get', params: search ? { search } : {}, loadingBar: true })
}

export const get_commessa = (id) => {
    return request({ url: `/commesse/${id}`, method: 'get', loadingBar: true })
}

export const create_commessa = (par) => {
    return request({ url: '/commesse', method: 'post', data: par, loadingBar: true })
}

export const update_commessa = (id, par) => {
    return request({ url: `/commesse/${id}`, method: 'put', data: par, loadingBar: true })
}

export const delete_commessa = (id) => {
    return request({ url: `/commesse/${id}`, method: 'delete', loadingBar: true })
}

export const delete_posizione = (commessaId, id) => {
    return request({ url: `/commesse/${commessaId}/posizioni/${id}`, method: 'delete', loadingBar: true })
}

export const duplica_posizione = (commessaId, id) => {
    return request({ url: `/commesse/${commessaId}/posizioni/${id}/duplica`, method: 'post', loadingBar: true })
}

export const get_posizioni = (commessaId) => {
    return request({ url: `/commesse/${commessaId}/posizioni`, method: 'get', loadingBar: true })
}

export const get_posizione = (commessaId, id) => {
    return request({ url: `/commesse/${commessaId}/posizioni/${id}`, method: 'get', loadingBar: true })
}

export const create_posizione = (commessaId, par) => {
    return request({ url: `/commesse/${commessaId}/posizioni`, method: 'post', data: par, loadingBar: true })
}

export const update_posizione = (commessaId, id, par) => {
    return request({ url: `/commesse/${commessaId}/posizioni/${id}`, method: 'put', data: par, loadingBar: true })
}
